export default __webpack_public_path__ + "static/media/loading.78a454a5.gif";